import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/tools/asset-library")({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router uses non-Error throw for control flow
    throw redirect({ to: "/asset-library", replace: true })
  },
  component: () => null,
})
